export default {
    name: "PanelRoundnessMixin",

    methods: {
        panelRoundnessStyle(value) {
            let roundnessValue = this.panelRoundnessValue(value);

            return `border-radius: ${ roundnessValue }px !important;`
        },

        panelRoundnessValue(value) {
            if (value === 0) {
                return 0;
            }

            if (value > 0 && value <= 33) {
                return 4;
            }

            if (value > 33 && value <= 66) {
                return 8;
            }

            if (value > 66 && value <= 100) {
                return 16;
            }
        }
    }
};